const sm2 = require('sm-crypto').sm2;
const publicKey = '04be87cae8cff8fbafce44f04bc4a36c58be9139a47c3857f030dace1b99791e557a712b95930f2e14270b7c49b05c34375af9f38a15cc6a55eb5ba1f076de13a3'; 
 
export const encryptPassword = (password) => {
  return sm2.doEncrypt(password,  publicKey, 1); // 1为默认模式 
};


/**
 * SM2解密方法 
 * @param {string} cipherText 密文（需确认是否含04前缀）
 * @param {string} privateKey 后端返回的临时私钥 
 * @param {number} cipherMode 模式：1-C1C3C2（默认），0-C1C2C3
 */
export const decryptSM2 = (cipherText, privateKey, cipherMode = 1) => {
  try {
    // 根据后端要求处理04前缀（Java需保留，Python需移除）[4]()
    const cleanCipher = cipherText.startsWith('04')  ? cipherText.slice(2)  : cipherText;
    return sm2.doDecrypt(cleanCipher,  privateKey, cipherMode);
  } catch (error) {
    console.error(' 解密失败:', error);
    return '';
  }
};


// WEBPACK FOOTER //
// ./src/assets/js/crypto.js